global.ReactComponents = global.ReactComponents || {}

import ReactDOM from 'react-dom';
import { getQuizData, quizSelector } from 'redux/reducers/quiz-reducer';

import React from 'react'
import { Provider } from 'react-redux'
import { setQuizData } from 'redux/reducers/quiz-reducer';
import store from 'redux/store/configureStore';
import WizardTool from './wizardTool';


global.canUseDOM = !(typeof window === "undefined");
if (global.canUseDOM) {
    window.store = store;
    // store kan nu tilgås fra window eks store.dispatch({type:"ACTIONSLHFA", psaf:})
}

class StoreConnected extends React.Component {
    componentWillMount() {
        if (this.props) {
            store.dispatch(setQuizData(this.props))
        }
    }

    render() {
        return (
            <Provider store={store}>
                <WizardTool {...this.props} />
            </Provider>
        )
    }
}

global.ReactComponents = { "WizardToolComp": StoreConnected }

if (global.canUseDOM) {
    require("./setup/reactComponentMounter").default(global.ReactComponents);
}
